import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';

export function useProjectIntegrations(projectId) {
  return useQuery({
    queryKey: ['project-integrations', projectId],
    queryFn: async () => {
      const { data } = await api.get(`/projects/${projectId}/integrations`, { skipProject: true });
      return data;
    },
    enabled: !!projectId,
  });
}

export function useUpdateIntegration(projectId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ type, ...payload }) => {
      const { data } = await api.patch(
        `/projects/${projectId}/integrations/${type}`,
        payload,
        { skipProject: true }
      );
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['project-integrations', projectId] }),
  });
}

export function useVerifyIntegration(projectId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (type) => {
      const { data } = await api.post(
        `/projects/${projectId}/integrations/${type}/verify`,
        {},
        { skipProject: true }
      );
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['project-integrations', projectId] }),
  });
}
